import { Button, Card, CardContent, Grid, Typography, Box } from '@mui/material';
import { theme } from 'theme';
import { palette } from 'theme/palette';
import { useNavigate } from 'react-router';
import { selectPartnerId } from 'selectors/partnerStatusSelector';
import { useSelector } from 'react-redux';
import EmbeddedIFrame from 'components/common/EmbeddedIFrame';
import { videoIdentificationStyles } from 'views/VideoIdentification/VideoIdentificationFormActions';
import { RootState } from 'store';

export const SubscriptionManagementContainer = () => {
  const partnerId = useSelector(selectPartnerId);
  const navigate = useNavigate();

  const CMP_URL = useSelector((state: RootState) => state.appConfig.CMP_URL);

  const handleCancel = () => {
    if (partnerId) {
      navigate(`/partner?partnerNumber=${partnerId}`);
    }
  };

  return (
    <Grid style={{ paddingLeft: theme.spacing(4) }}>
      <Typography variant="h1"> SUBSCRIPTION MANAGEMENT </Typography>
      <Card
        id={'subscription-management-container'}
        style={{ maxWidth: '90%', marginBottom: theme.spacing(14), padding: 0 }}
        square
      >
        <Grid container>
          <EmbeddedIFrame
            url={`${CMP_URL}/bsicrm/?dl=subscription-mask-${partnerId}`}
            title={'Subscription Management'.toUpperCase()}
            id={'subscription-management-iframe'}
            height={'90%'}
            width={'50%'}
            positionLeft={'50%'}
          />
        </Grid>
        <CardContent style={{ padding: 0, paddingLeft: theme.spacing(2) }}>
          <Box sx={videoIdentificationStyles.actions}>
            <Button
              id="cancel-subscription-management-button"
              data-testid="cancel-subscription-management-button"
              onClick={handleCancel}
              variant="outlined"
              style={{ color: palette.black }}
            >
              Cancel
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};
